import type { FC, FormEvent } from 'react';

import type { OauthHeaderProps } from '../../components';
import { Button, Error, Header, Input, Layout, OauthHeader } from '../../components';
import { getErrorForField } from '../../helpers';
import type { ResponseError } from '../../types';
import TwoFactorIcon1xPng from './assets/twofactor-icon.png';
import TwoFactorIcon1xWebp from './assets/twofactor-icon.webp';
import TwoFactorIcon15xPng from './assets/twofactor-icon@1_5x.png';
import TwoFactorIcon15xWebp from './assets/twofactor-icon@1_5x.webp';
import TwoFactorIcon2xPng from './assets/twofactor-icon@2x.png';
import TwoFactorIcon2xWebp from './assets/twofactor-icon@2x.webp';
import { ButtonWrapper, Center, InputWrapper } from './styles';
import type { TwoFactorFormDataType } from './types';

interface TwoFactorPageProps {
    text: Record<string, string>;
    oauthDetail?: OauthHeaderProps;
    logoutHref: string;
    loading: boolean;
    formData: TwoFactorFormDataType;
    error: ResponseError | null;
    onFormDataChange: (data: TwoFactorFormDataType) => void;
    onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

const TwoFactorPage: FC<TwoFactorPageProps> = ({
    loading,
    error,
    formData,
    text,
    logoutHref,
    oauthDetail,
    onSubmit,
    onFormDataChange,
}) => (
    <Layout narrow>
        <Center>
            <form onSubmit={onSubmit}>
                {oauthDetail && <OauthHeader {...oauthDetail} />}
                <div>
                    <picture>
                        <source
                            srcSet={`${TwoFactorIcon1xWebp} 1x, ${TwoFactorIcon15xWebp} 1.5x, ${TwoFactorIcon2xWebp} 2x, `}
                            type="image/webp"
                        />
                        <source
                            srcSet={`${TwoFactorIcon1xPng} 1x, ${TwoFactorIcon15xPng} 1.5x, ${TwoFactorIcon2xPng} 2x, `}
                            type="image/png"
                        />
                        <img src={TwoFactorIcon1xPng} width="80" alt="Two-factor authentication" />
                    </picture>
                </div>
                {text.heading && <Header>{text.heading}</Header>}
                {text.line1 && <p>{text.line1}</p>}
                {text.line2 && <p>{text.line2}</p>}
                <InputWrapper>
                    <Input
                        placeholder={text?.placeholder}
                        value={formData.code}
                        onChange={(e) => {
                            if (e.target.value.length <= 6) {
                                onFormDataChange({ code: e.target.value });
                            }
                        }}
                    />
                </InputWrapper>
                {getErrorForField(error, 'code')?.map((msg) => (
                    <Error key={msg}>{msg}</Error>
                ))}
                <ButtonWrapper>
                    <div>
                        <Button variant="primary" type="submit" loading={loading}>
                            Verify code
                        </Button>
                    </div>
                    <div>
                        <Button href={logoutHref} outlined>
                            Logout
                        </Button>
                    </div>
                </ButtonWrapper>
            </form>
        </Center>
    </Layout>
);

export default TwoFactorPage;
